export const headers = [
	{
		label: 'Dénomination du cookie',
		width: '180px'
	},
	{
		label: 'Finalité',
		width: '328px'
	},
	{
		label: 'Durée de conservation',
		width: '180px'
	}
];
